import { queryClient } from '@/queryClient'

export const readCache = <T, TData>(key: T): TData | undefined => {
  const keyData = Array.isArray(key) ? key : [key]
  return queryClient.getQueryData(keyData)
}

export const updateCache = <T, TData>(key: T, field = null, value: TData): void => { // Use when update single data in cache
  const keyData = Array.isArray(key) ? key : [key]
  queryClient.setQueriesData({
    queryKey: keyData
  }, (oldData) => {
    if(!field) {
      return value
    } else {
      return {
        ...oldData as TData,
        [field]: value
      }
    }
  })
}